export default "__VITE_ASSET__9bef51a0__"